import { createGlobalStyle } from 'styled-components';

import SourceSansProBold from '@/assets/fonts/source-sans-pro-bold.woff';

const VariationStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBold';
    src: url(${SourceSansProBold});
    font-weight: bold;
    font-style: normal;
  }

  .generated-images-holder-var13 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var13 {
    width: 100%;
    position: relative;
    height: 1350px;
  }
 
  .bottom-text-var13 {
    position: absolute;
    bottom: 108px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 60px;
    line-height: 1.2;
    letter-spacing: -1.3px;
    color: #fff;
    text-align: center;
    font-family: SourceSansProBold;
    z-index: 1;
    text-transform: uppercase;
    p {
      background-color: #000;
      display: inline-block;
      margin: 0;
      padding: 17px 47px 22px;
      position: relative;
    }
  }
  .triangle-icon-var13 { 
    position: absolute;
    bottom: -44px;
    left: -1px;
    display: block;
  }

  .full-image-var13 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .circle-image-var13 {
    object-fit: cover;
    border-radius: 50%;
    border: solid 12px white;
    width: 474px;
    height: 474px;
    position: absolute;
    top: -536px;
    right: 40px;
    &.position-left {
      left: 40px;
      right: auto;
    }
    &.position-custom {
      bottom: auto;
      right: auto;
    }
  }
  
  .logo-watermark-var13 {
    position: absolute;
    top: 42px;
    left: 42px;
  }
`;

export default VariationStyles;
